import { render, staticRenderFns } from "./Historie.vue?vue&type=template&id=601e2620"
import script from "./Historie.vue?vue&type=script&lang=js"
export * from "./Historie.vue?vue&type=script&lang=js"
import style0 from "./Historie.vue?vue&type=style&index=0&id=601e2620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports